import {
    SET_TRACKIER_DAILY,
    CLEAR_TRACKIER_DAILY,
    GET_TRACKIER_DAILY_SUCCESS,
    GET_TRACKIER_DAILY_FAILED,
} from '../../actions/type';

const initialState = { data: null, status: 'idle' };

export default function trackierDailyReducer(state = initialState, action) {
    const { type, data } = action;

    switch (type) {
        case SET_TRACKIER_DAILY:
            return {
                ...state,
                data,
            }
        case CLEAR_TRACKIER_DAILY:
            return {
                ...state,
                data: null,
            }
        case GET_TRACKIER_DAILY_SUCCESS:
            return {
                ...state,
                status: 'success',
            }
        case GET_TRACKIER_DAILY_FAILED:
            return {
                ...state,
                error: data,
                status: 'failed',
            }

        default:
            return state;
    }
}